import React, { useState } from "react";
import { Heart, Copy, Check, Wallet } from "lucide-react";
import { toast } from "sonner";
import { ViewModal } from "./ViewModal";

const DONATION_METHODS = [
  {
    id: "paypal",
    title: "PayPal",
    description: "Send a tip directly to the official BendyWheels account.",
    action: "Open PayPal",
    icon: Heart,
    kind: "link",
    value: "dorelchetia19@gmail.com",
    href: "https://www.paypal.com/paypalme/dorelchetia19",
  },
  {
    id: "bsc",
    title: "BNB Smart Chain",
    description: "Send BNB or any BEP-20 token to this wallet.",
    action: "Copy address",
    icon: Wallet,
    kind: "copy",
    value: "0x7258c7a36e2c7B1ddd8aE3B816EC0191af42e75a",
  },
];

const DonationRow = ({ m }) => {
  const [copied, setCopied] = useState(false);
  const Icon = m.icon;

  const handle = async () => {
    if (m.kind === "copy") {
      try {
        await navigator.clipboard.writeText(m.value);
        setCopied(true);
        toast("Address copied to clipboard", {
          description: m.value,
        });
        setTimeout(() => setCopied(false), 2000);
      } catch {
        toast("Could not copy the address");
      }
    } else if (m.kind === "link") {
      window.open(m.href, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div
      className="relative flex items-center gap-4 p-4"
      style={{ backgroundColor: "#111", border: "1px solid #1e1e1e", borderRadius: 4 }}
      data-testid={`donation-${m.id}`}
    >
      <div
        className="w-12 h-12 flex-shrink-0 flex items-center justify-center"
        style={{ backgroundColor: "#FFD400", borderRadius: 2 }}
      >
        <Icon size={22} color="#111" />
      </div>
      <div className="flex-1 min-w-0">
        <div
          className="text-sm font-black uppercase tracking-widest text-white"
          style={{ fontFamily: "Orbitron, sans-serif" }}
        >
          {m.title}
        </div>
        <div className="text-xs text-white/60 mt-0.5">{m.description}</div>
        {m.value && (
          <div className="mt-1 flex items-center gap-2">
            <span
              className="text-[10px] truncate text-white/50"
              style={{ fontFamily: "monospace" }}
              title={m.value}
              data-testid={`donation-value-${m.id}`}
            >
              {m.value}
            </span>
            <button
              type="button"
              onClick={async (e) => {
                e.stopPropagation();
                try {
                  await navigator.clipboard.writeText(m.value);
                  setCopied(true);
                  toast("Copied to clipboard", { description: m.value });
                  setTimeout(() => setCopied(false), 2000);
                } catch {
                  toast("Could not copy");
                }
              }}
              aria-label="Copy"
              className="text-white/40 hover:text-[#FFD400] flex-shrink-0"
              data-testid={`donation-copy-${m.id}`}
            >
              {copied ? <Check size={11} /> : <Copy size={11} />}
            </button>
          </div>
        )}
      </div>
      <button
        type="button"
        onClick={handle}
        className="px-3 py-2 text-[10px] font-black uppercase tracking-[0.25em] transition-colors hover:bg-white flex items-center gap-1.5 flex-shrink-0"
        style={{
          backgroundColor: "#FFD400",
          color: "#111",
          fontFamily: "Orbitron, sans-serif",
          borderRadius: 2,
        }}
        data-testid={`donation-action-${m.id}`}
      >
        {m.kind === "copy" && copied ? (
          <>
            <Check size={12} />
            Copiado
          </>
        ) : (
          <>
            {m.kind === "copy" && <Copy size={12} />}
            {m.action}
          </>
        )}
      </button>
    </div>
  );
};

export const DonationsView = ({ open, onClose }) => {
  return (
    <ViewModal
      open={open}
      onClose={onClose}
      title="Donations"
      subtitle="Support BendyWheels development"
      testId="donations-view"
    >
      <div
        className="p-4 mb-4"
        style={{
          backgroundColor: "#111",
          border: "1px solid #FFD400",
          borderRadius: 4,
        }}
      >
        <p className="text-sm text-white/80 leading-relaxed">
          <span
            style={{ color: "#FFD400", fontFamily: "Orbitron, sans-serif", fontWeight: 800 }}
          >
            Thanks for playing!
          </span>{" "}
          BendyWheels is an independent project. If you enjoy it and want to see
          more eras, achievements and upgrades, every tip is welcome. All
          proceeds go directly to the game&apos;s development.
        </p>
      </div>

      <div className="flex flex-col gap-3">
        {DONATION_METHODS.map((m) => (
          <DonationRow key={m.id} m={m} />
        ))}
      </div>
    </ViewModal>
  );
};

export default DonationsView;
